import React from 'react';
import { getStorageUser } from '../../../helpers/api_helper';
import { resourcesFiles } from '../../../helpers/backend_helper';

const Columns = ( addUpd, destroy) => {
	const authUser = getStorageUser();
/*
	if (authUser.id != row.administrator_id) {
		let admin_name = {
			id: 'admin_name',
			name: 'Administrador',
			selector: row => row.admin_name,
			sortable: true,
			wrap: true,
			width:'40%'
		}
	}else{

	}
*/
	const getFiles = (id) =>{
		let params={params:{relation:'operator',id:id,field:'operator_id'}}
		resourcesFiles('get',params).then(response => {
        	setModalFile({show:true,id:id,items:response.files});
        })
	}

	let columns = [
		{
			id: 'name',
			name: 'Nombre',
			selector: row => row.full_name,
			sortable: false,
		},
		{
			id: 'rfid',
			name: 'RFID',
			selector: row => row.rfid,
			sortable: false,
		},
		{
			id: "is_student",
			name: "Es estudiante",
			selector: (row) => row.is_student ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-secondary"></i>,
			width: "120px",
			center: true,
		},
		{
			id: "is_third_age",
			name: "Es tercera edad",
			selector: (row) => row.is_third_age ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-secondary"></i>,
			width: "120px",
			center: true,
		},
		{
			id: "is_handicapped",
			name: "Es discapacitado",
			selector: (row) => row.is_handicapped ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-secondary"></i>,
			width: "120px",
			center: true,
		},
		{
			id: 'actions',
			name: 'Acciones',
			width:'20%',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					
					<div className="pe-2">
						<button className="btn btn-primary btn-sm" title='Editar operador' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
					</div>
					<div className="pe-2">
						<button className="btn btn-danger btn-sm" title='Eliminar operador' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
					</div>
				</div>
				),
		}
	];

	if (authUser.profile_id == 2) {
		columns = [
		  {
			id: "ruta",
			name: "Ruta",
			selector: (row) => row.route.name,
			sortable: true,
		  },
		  ...columns,
		];
	  }


	return columns;
}

export default Columns;